import { RolePermissions } from "src/app/model/rolePermissions";
import { TipologiaUtente } from "src/app/model/utente/utente";


export class RoleUtils {

    public static checkRole(role: any) {

        const rolePermission = new RolePermissions();

        switch (role) {
            case TipologiaUtente.ISPETTORE_ASSQUAL:
            case TipologiaUtente.RESPONSABILE_ASSQUAL:
                rolePermission.canViewHomeBtn = true;
                rolePermission.canViewNotificationsBtn = true;
                rolePermission.canViewOrdersBtn = true;
                rolePermission.canViewInspectionsBtn = true;
                rolePermission.canViewReleasesBtn = true;
                rolePermission.canViewNonCompliancesBtn = true;
                rolePermission.canViewDocumentsBtn = true;
                rolePermission.canViewTrashBtn = true;
                rolePermission.canViewSettingsBtn = true;
                rolePermission.canViewLogoutBtn = true;
                rolePermission.canViewArchiviBtn = true;
                return rolePermission
            case TipologiaUtente.FORNITORE:
                rolePermission.canViewHomeBtn = true;
                rolePermission.canViewNotificationsBtn = true;
                rolePermission.canViewOrdersBtn = true;
                rolePermission.canViewInspectionsBtn = true;
                rolePermission.canViewReleasesBtn = true;
                rolePermission.canViewNonCompliancesBtn = true;
                rolePermission.canViewDocumentsBtn = true;
                rolePermission.canViewTrashBtn = false;
                rolePermission.canViewSettingsBtn = true;
                rolePermission.canViewLogoutBtn = true;
                rolePermission.canViewArchiviBtn = true;
                return rolePermission
            case TipologiaUtente.UTENTE_ESTERNO:
                rolePermission.canViewHomeBtn = true;
                rolePermission.canViewNotificationsBtn = true;
                rolePermission.canViewOrdersBtn = true;
                rolePermission.canViewInspectionsBtn = true;
                rolePermission.canViewReleasesBtn = true;
                rolePermission.canViewNonCompliancesBtn = true;
                rolePermission.canViewDocumentsBtn = true;
                rolePermission.canViewTrashBtn = false;
                rolePermission.canViewSettingsBtn = true;
                rolePermission.canViewLogoutBtn = true;
                rolePermission.canViewArchiviBtn = true;
                return rolePermission
            case TipologiaUtente.UTENTE_INTERNO:
            case TipologiaUtente.PIAMAT:
                rolePermission.canViewHomeBtn = true;
                rolePermission.canViewNotificationsBtn = true;
                rolePermission.canViewOrdersBtn = true;
                rolePermission.canViewInspectionsBtn = true;
                rolePermission.canViewReleasesBtn = true;
                rolePermission.canViewNonCompliancesBtn = true;
                rolePermission.canViewDocumentsBtn = true;
                rolePermission.canViewTrashBtn = false;
                rolePermission.canViewSettingsBtn = true;
                rolePermission.canViewLogoutBtn = true;
                rolePermission.canViewArchiviBtn = true;
                return rolePermission
            case TipologiaUtente.ADMIN:
                rolePermission.canViewHomeBtn = false;
                rolePermission.canViewNotificationsBtn = false;
                rolePermission.canViewOrdersBtn = false;
                rolePermission.canViewInspectionsBtn = false;
                rolePermission.canViewReleasesBtn = false;
                rolePermission.canViewNonCompliancesBtn = false;
                rolePermission.canViewDocumentsBtn = false;
                rolePermission.canViewTrashBtn = false;
                rolePermission.canViewSettingsBtn = false;
                rolePermission.canViewLogoutBtn = true;
                rolePermission.canViewArchiviBtn = false;
                rolePermission.canViewAdminBtn = true;
                return rolePermission;
            default:
                rolePermission.canViewHomeBtn = false;
                rolePermission.canViewNotificationsBtn = false;
                rolePermission.canViewOrdersBtn = false;
                rolePermission.canViewInspectionsBtn = false;
                rolePermission.canViewReleasesBtn = false;
                rolePermission.canViewNonCompliancesBtn = false;
                rolePermission.canViewDocumentsBtn = false;
                rolePermission.canViewTrashBtn = false;
                rolePermission.canViewSettingsBtn = false;
                rolePermission.canViewLogoutBtn = false;
                rolePermission.canViewArchiviBtn = false;
                return rolePermission
        }
    }


}